// src/data/trainers.ts — Entrenadores Ruta Aurelia Fase 4
import type { AsteriaSpecies } from '../entities/asteria.js';

export type TrainerDef = {
  id: string;
  name: string;
  title: string;
  zone: 'ruta_aurelia';
  x: number; y: number;
  facing: 'north'|'south'|'east'|'west';
  dialogue: string[]; // antes
  dialogueWin: string[]; // si gana jugador
  dialogueLose: string[]; // si pierde
  team: { speciesId:string; level:number }[];
  reward: { aureos:number; items?: {id:string; qty:number}[] };
  color: string;
};

export const TRAINERS: TrainerDef[] = [
  {
    id:'mira_aventurera',
    name:'Mira',
    title:'Aventurera del Puente',
    zone:'ruta_aurelia',
    x:16, y:7,
    facing:'south',
    color:'#ff6b6b',
    dialogue:["¡Eh! ¿Te crees listo para cruzar mi puente?", "¡Demuéstralo en combate! Yo no dejo pasar a cualquiera."],
    dialogueWin:["¡Increíble! Tienes madera de explorador.", "Toma 40 aureos. Úsalos en el Bazar de Liora."],
    dialogueLose:["Je, te falta calle.", "Vuelve cuando tus Asterias estén más fuertes."],
    team:[
      { speciesId:'verdora', level:5 },
      { speciesId:'voltine', level:5 },
    ],
    reward:{ aureos:40, items:[{id:'nucleo_vinculo', qty:2}] }
  }
];

export function getTrainer(id:string): TrainerDef | undefined { return TRAINERS.find(t=>t.id===id); }
